module.exports = __webpack_public_path__ + "static/feature-phone-1-e80d36663ed37adf875e7667d431f1c2.png";